// Component displaying for Page title

import React from "react";
import { Row, Image, Card, Col } from "react-bootstrap";
import './Salute.css';
import MrgImg from '../../../../../assets/images/widgets/sunrise.png';
import EvgImg from '../../../../../assets/images/widgets/sunset.png';
import NoonImg from '../../../../../assets/images/widgets/afternoon.png';

const SaluteCard = ({props}) => {

    const today = new Date()
    const curHr = today.getHours()

    // UI to render
    return (
    <Row className="salute">
        <Col md={6} sm={12}>
            <Card className="saluteCard">
                <Card.Body>
                    { curHr < 12 &&
                        <Row className="saluteRow">
                            <Col md={'2'}>
                                <Image className="profile-pic" alt={"TBD good morning"} src={MrgImg}/>
                            </Col>
                            <Col md={'10'}>
                                <h2 className="saluteText">Good Morning <b>{props.firstName}</b> !</h2>
                            </Col>
                        </Row>
                    }
                    { curHr >= 12 && curHr < 18 &&
                        <Row className="saluteRow">
                            <Col md={'2'}>
                                <Image className="profile-pic" alt={"TBD good afternoon"} src={NoonImg}/>
                            </Col>
                            <Col md={'10'}>
                                <h2 className="saluteText">Good Afternoon <b>{props.firstName}</b> !</h2>
                            </Col>
                        </Row>
                    }
                    { curHr >= 18 &&
                        <Row className="saluteRow">
                            <Col md={'2'}>
                                <Image className="profile-pic" alt={"TBD good evening"} src={EvgImg}/>
                            </Col>
                            <Col md={'10'}>
                                <h2 className="saluteText">Good Evening <b>{props.firstName}</b> !</h2>
                            </Col>
                        </Row>
                    }
                </Card.Body>
            </Card>
        </Col>
    </Row>
    )
};

export default SaluteCard;
